import { render, staticRenderFns } from "./c_product.vue?vue&type=template&id=ec7a59ee&scoped=true&"
import script from "./c_product.vue?vue&type=script&lang=js&"
export * from "./c_product.vue?vue&type=script&lang=js&"
import style0 from "./c_product.vue?vue&type=style&index=0&id=ec7a59ee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7a59ee",
  null
  
)

export default component.exports